import "./stylesheets/GlobalStyles.css";
import "github-markdown-css/github-markdown.css";

import React from "react";

import ScreenManager from "./manager/ScreenManager";
import ScreenManagerComponent from "./components/ScreenManagerComponent";

import WelcomeScreen from "./screens/WelcomeScreen";
import PagesOverviewScreen from "./screens/PagesOverviewScreen";
import Page from "./components/Page";
import EditEntryScreen from "./screens/EditEntryScreen";
import LoginScreen from "./screens/LoginScreen";
import AddEntryScreen from "./screens/AddEntryScreen";
import ThanksForSubmitScreen from "./screens/ThanksForSubmitScreen";
import CaptchaScreen from "./screens/CaptchaScreen";

const URL_PREFIX = "/transparencyportal";

/**
 *                    ------------------------------------------
 *                    -          ADD NEW SCREENS HERE          -          
 *                    ------------------------------------------
 * 
 * This array contains all information about the screens. At least routeName and screen must
 * be given to be able to display the screen and navigate to it.
 * 
 * Please note that it is NECESSARY to add {this.props.children} to the render method of the
 * given screen component to be able to display errors and notifications.
 * 
 * Icons: An icon will be displayed if it is given in the object. The icon object must have
 * the icon source component (eg. "import AntDesign from 'react-icons/AntDesign'") and the
 * name of the icon in the given component ( @see https://react-icons.netlify.com/ ). A color
 * can optionally be passed as well (eg. "white" or "#F0F0F0").
 * 
 * So an object in the array looks like this:
 * {
        routeName: "MyScreenAliasForNavigation",
        screen: MyScreen,           // imported from MyScreen.js
        title: "My Title",          // [OPTIONAL]
        navTitle: "Shorttitle"      // [OPTIONAL] shown in the navbar together with the icon
        icon: {                     // [REQUIRED FOR NAVTITLE]
            component: FaBook,      // imported from "react-icons/*"
            color: "#F0F0F0"        // [OPTIONAL] common color names are possible too
        }
    }
 */
const SCREEN_ARRAY = [
    {
        path: URL_PREFIX+"/",
        initialRouteName: "Login",
        screens: [
            {
                routeName: "Welcome",
                screen: WelcomeScreen
            },
            {
                routeName: "PagesOverview",
                screen: PagesOverviewScreen
            },
            {
                routeName: "Page",
                screen: Page
            },
            {
                routeName: "EditEntry",
                screen: EditEntryScreen,
                title: "Eintrag bearbeiten"
            },
            {
                routeName: "Login",
                screen: LoginScreen
            }
        ]
    },
    {
        path: URL_PREFIX+"/leak/",
        screens: [
            {
                routeName: "Captcha",
                screen: CaptchaScreen
            },
            {
                routeName: "AddEntry",
                screen: AddEntryScreen
            },
            {
                routeName: "ThanksForSubmit",
                screen: ThanksForSubmitScreen
            }
        ]
    }
];

// initialize the screenmanager
const screenManager = ScreenManager.instance;
screenManager.initialize( SCREEN_ARRAY );

export default function() {

    // The reference of this component is passed to the screenmanager to be able to rerender/ change screen
    return <ScreenManagerComponent ref={ref => screenManager.screenManagerComponent = ref} />;

}